export const pushError = ({commit, dispatch}, {error}) => {
  commit('pushError', {error})
  setTimeout(() => {
    dispatch('popError')
  }, 1500)
}

export const popError = ({state, commit}) => {
  if (state.errors.length) {
    commit('popError')
  }
}



// WEBPACK FOOTER //
// ./src/store/errors/actions.js